export function Logo({ size = 36, light = false }) {
  const green = light ? "#FAF7F2" : "#1A3C2A";
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Nabor logo">
      <rect x="2" y="2" width="44" height="44" rx="13" fill={green} />
      <path d="M14 34V18.5L24 26.5L34 18.5V34" stroke="#FAF7F2" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M12 20L24 11L36 20" stroke="#E07A5F" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="24" cy="36.5" r="2.2" fill="#E07A5F" />
    </svg>
  );
}

export function LogoWord({ light = false }) {
  return (
    <div className="flex items-center gap-2">
      <Logo size={34} light={light} />
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-[#FAF7F2]" : "text-[#1A3C2A]"}`}>
        Nabor
      </span>
    </div>
  );
}
